var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8358_478012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8358_478012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74468 18L2 17.2222L7.26596 11.7222C7.79787 11.1852 8.4273 10.9119 9.15426 10.9022C9.88121 10.8933 10.5106 11.1667 11.0426 11.7222L12.266 13C12.5851 13.3333 12.9617 13.4956 13.3957 13.4867C13.8305 13.477 14.2074 13.3148 14.5266 13L20.1915 7.11111H16.6809V6H22V11.5556H20.9362V7.91667L15.2713 13.7778C14.7571 14.3148 14.1319 14.5881 13.3957 14.5978C12.6603 14.6067 12.0355 14.3426 11.5213 13.8056L10.2713 12.5C9.95213 12.1667 9.57518 12.0044 9.14043 12.0133C8.70638 12.023 8.32979 12.1852 8.01064 12.5L2.74468 18Z",
    fill: "#7D899D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoving);
export default __webpack_public_path__ + "static/media/moving.b93d8fcc.svg";
export { ForwardRef as ReactComponent };